import { ActionReducer } from '@ngrx/store';
import { demographicsEditorRecordsState } from './demographics-editor.model';
import { initialState, SEARCH_DEMOGRAPHICS_EDITOR_RECORDS, GET_DEMOGRAPHICS_EDITOR_RECORDS, RESET_DEMOGRAPHICS_EDITOR_RECORDS_GRID_DATA, RESET_DEMOGRAPHICS_EDITOR_RECORDS_TO_INITIAL_STATE } from './demographics-editor.constants';
import { CLEAR_ALL_STORES_STATE, CustomAction } from '../index-store.constants';

export function demographicsEditorRecordsReducer(state: demographicsEditorRecordsState = initialState, action: CustomAction) {
    switch (action.type) {
        case SEARCH_DEMOGRAPHICS_EDITOR_RECORDS:
            return {
                patientRecordsSearchFilterFields: action.payload,
                patientRecordsSearchGridData: state.patientRecordsSearchGridData
            };
        case GET_DEMOGRAPHICS_EDITOR_RECORDS:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: {
                    rowsPerPageOptions: state.patientRecordsSearchGridData.rowsPerPageOptions,
                    cols: state.patientRecordsSearchGridData.cols,
                    pageLinks: state.patientRecordsSearchGridData.pageLinks,
                    rows: action.payload.rows,
                    configuration: action.payload.configuration,
                    filterData: action.payload.filterData,
                    totalRecords: action.payload.totalRecords
                }
            };
        case RESET_DEMOGRAPHICS_EDITOR_RECORDS_GRID_DATA:
            return {
                patientRecordsSearchFilterFields: state.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        case RESET_DEMOGRAPHICS_EDITOR_RECORDS_TO_INITIAL_STATE:
        case CLEAR_ALL_STORES_STATE:
            return {
                patientRecordsSearchFilterFields: initialState.patientRecordsSearchFilterFields,
                patientRecordsSearchGridData: initialState.patientRecordsSearchGridData
            };
        default:
            return state;
    }
}
